module.exports = __webpack_public_path__ + "media/impala_m.66285842.mp3";